import { VALTYPES } from '../../../../data/interfaces';
import { categoricalOrderOptions } from '../../helpers/categoricalSorters';
import { createConfigParamBoolean, createConfigParamMultipleChoice } from '../../helpers/configParams';

import { TpChartManifest } from '../interfaces';
import { FacetCategorical } from './FacetCategorical';

export const manifestFacetCategorical: TpChartManifest = {
  id: 'FacetCategorical',
  name: 'Categorical facet',
  description: `Displays the distribution of a categorical property by showing the number of occurrences of each different state.

This plot offers a few benefits over a standard bar graph, making it well suited for facetted filtering:
- Scales to a very large number of states, with a paged UX.
- The user can search for specific states.`,
  component: FacetCategorical,
  canvasBased: false,
  groups: [
    { groupId: 'cats', groupName: 'Categories' },
    { groupId: 'layout', groupName: 'Layout' },
  ],

  aspects: [
    {
      id: 'categories',
      name: 'Categories data',
      description: 'Property to show the states and occurrences for.',
      groupId: 'cats',
      required: true,
      quality: 1,
      dataType: [VALTYPES.CATEGORICAL, VALTYPES.MULTICAT],
    },
  ],
  configParams: [
    {
      id: 'simpleLayout',
      name: 'Simple Layout',
      description: 'If set, the widget does not show a pager or a search bar.',
      groupId: 'layout',
      paramType: createConfigParamBoolean(false),
    },
    {
      id: 'sortBy',
      name: 'Sort by',
      groupId: 'cats',
      description: 'How to sort the categorical values.',
      paramType: createConfigParamMultipleChoice(categoricalOrderOptions),
    },
  ],
  examples: [
    {
      id: 'catfacet_1',
    },
    {
      id: 'catfacet_2',
    },
  ],
};
